<template>
  <a-modal
    class="company-modal-wrapper"
    width="850px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    title="查看积分"
    @cancel="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
      :scroll="{ y: 300 }"
    >
      <template
        slot="create_time"
        slot-scope="text, record"
      >
        {{ $Moment(record.create_time).format('YYYY-MM-DD') }}
      </template>
    </a-table>
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          width: 150,
        },
        {
          title: '学分',
          dataIndex: 'score',
          width: 150,
        },
        {
          title: '备注',
          dataIndex: 'action',
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          scopedSlots: { customRender: 'create_time' },
          width: 200,
        },

      ],
    };
  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="scss" scoped>

</style>